import { registerEnum } from '@cbbt/lib-interface';
var OnboardingOrganisationType;
(function (OnboardingOrganisationType) {
    OnboardingOrganisationType["CLUB_OR_ASSOCIATION"] = "Club or Association";
    OnboardingOrganisationType["PRIVATE_LIMITED"] = "Private Limited";
    OnboardingOrganisationType["SOLE_TRADER"] = "Sole Trader";
})(OnboardingOrganisationType || (OnboardingOrganisationType = {}));
registerEnum(OnboardingOrganisationType, ' OnboardingOrganisationType');
export { OnboardingOrganisationType };
//# sourceMappingURL=OnboardingOrganisationType.js.map